import { createContext, useMemo, useEffect, useState, useContext } from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { selectBrandName } from '../brand/ducks/selectors.js';
import styledBaseTheme from './styled-base-theme.js';
import Loading from '../misc/loading.js';

const ThemeContext = createContext({});

export const ThemeProvider = ({ children }) => {
	const brandName = useSelector(selectBrandName);
	const [theme, setTheme] = useState(null);

	useEffect(() => {
		async function getBrandTheme() {
			const { default: t } = await import(
				/* webpackChunkName: "[request]" */
				`@komigen/${brandName}/components/index.js`
			);
			setTheme({ ...t });
		}
		getBrandTheme();
	}, [brandName]);

	const memoizedStyledTheme = useMemo(
		() =>
			!theme || {
				...styledBaseTheme,
				...theme?.styled,
				brand: brandName
			},
		[theme, brandName]
	);

	if (!theme) {
		return <Loading />;
	}

	return (
		<ThemeContext.Provider value={theme}>
			<StyledThemeProvider theme={memoizedStyledTheme}>{children}</StyledThemeProvider>
		</ThemeContext.Provider>
	);
};

export const useTheme = () => useContext(ThemeContext);

export default ThemeContext;
